<div class="error-page-container">
    <div class="error-page-title mt-5 mb-3 px-3">{{ 'NOT-FOUND.TEXT' | translate }}</div>
    <div class="error-page-message px-3">{{ 'NOT-FOUND.INFORM' | translate }}</div>
</div>